import * as v from 'valibot';

export const Stats = v.object({
	openClaimsNo: v.number(),
	closedClaimsNo: v.number(),
	fnolInProgressNo: v.number(),
	pendingInsuredNo: v.number(),
	pendingClaimsHandlerNo: v.number(),
	claimCalculatingNo: v.number(),
	calculationCompletedNo: v.number(),
});

export type Stats = v.InferOutput<typeof Stats>;
